module.exports = __webpack_public_path__ + "assets/roboto-bold.7165a1cbfc561437b4ada89108595b558b27fd0133e6da57e70eae40aa4ae129.woff";